<ng-container *ngIf="!useNoteTemplate else noteTemplate">

<ng-container>
  <section [style.position]="'relative'">

    <div id="placeholder_container" class="flex column center pos-relative">
      <div class="header" *ngIf="title">
        <p class="title">{{title}}</p>
        <ng-container *ngIf="!isDisabled && activeFiles?.length > 0 && showDragAndDrop">
          <ng-container *ngTemplateOutlet="filesContainer; context: {slim: true}"></ng-container>
        </ng-container>
        <button [ngClass]="isGalleryManager ? 'upload-file-btn home365-button primary inverted' : 'upload-file-link'" *ngIf="activeFiles?.length > 0 && !isDisabled && !showDragAndDrop"
             (click)="selectFile()">
          <ng-container *ngIf="allowMultipleFiles else singleFile">
            <div class="as-link">
              <input #fileInput hidden class="file-input" type="file" multiple [accept]="acceptedFileTypes"
                     (change)="addFiles($event)">
            </div>
          </ng-container>
          <i *ngIf="!isGalleryManager" class="fa-light fa-arrow-up-from-bracket pink"></i>
          <span id="upload-file-text" [ngClass]="{'as-link': !isGalleryManager}">
            <ng-container *ngIf="!isGalleryManager else galleryManagerBtnText">
              {{ allowMultipleFiles ? ('GENERAL_FORMS.UPLOAD_MULTIPLE_FILES' | translate) :
              ('GENERAL_FORMS.UPLOAD_SINGLE_FILE' | translate) }}
            </ng-container>
          </span>
        </button>
        <ng-template #galleryManagerBtnText>
          {{ allowMultipleFiles ? ('GENERAL_FORMS.ATTACH_FILES' | translate) :
          ('GENERAL_FORMS.ATTACH_FILE' | translate) }}
        </ng-template>
      </div>
      <ng-container *ngIf="activeFiles?.length === 0">
        <ng-container *ngTemplateOutlet="filesContainer"></ng-container>
      </ng-container>
      <ng-container *ngIf="showCarousel && activeFiles?.length">
        <ng-container *ngTemplateOutlet="carousel"></ng-container>
      </ng-container>
    </div>
  </section>

</ng-container>



<ng-template #carousel>
<!--  <carousel #myCarousel="carousel" (events)="handleCarouselEvents($event)" class="home365-carousel"-->
<!--            [cellsToShow]="cellsToShowCarousel" [images]="imagesCarousel" [cellWidth]="cellWidthCarousel" [arrowsOutside]="arrowsOutsideCarousel"-->
<!--            [borderRadius]="borderRadiusCarousel" [objectFit]="objectFitCarousel" [height]="heightCarousel" [arrowsTheme]="'dark'" [allowDelete]="!isDisabled">-->
<!--  </carousel>-->

  <lib-carousel
    (events)="handleCarouselEvents($event)" class="home365-carousel"
    [allowPrimaryCellsSelection]="allowPrimaryCellsSelection"
    [allowPrimaryTypes]="allowPrimaryTypes" [isOwner]="isOwner"
    [cellsToShow]="cellsToShowCarousel" [images]="imagesCarousel" [arrowsOutside]="true" [cellWidth]="cellWidthCarousel" [height]="heightCarousel"
    [borderRadius]="borderRadiusCarousel" [objectFit]="objectFitCarousel"  [arrowsTheme]="'dark'" [allowDelete]="!isDisabled"
    [leftArrow]="-40" [isGalleryManager]="isGalleryManager"
  ></lib-carousel>
</ng-template>




<ng-template #filesContainer let-slim="slim">
  <ng-container *ngIf="dragAndDrop else noDragAndDrop">
    <div *ngIf="!isDisabled" class="file-drop-area" appDragAndDrop
         
         (fileDropped)="addFiles($event)"
         [style.position]="slim ? 'absolute' : ''"
         [style.top]="slim && !isGalleryManager  ? '16px' : ''"
         [style.right]="slim ? '16px' : ''"
         [style.height]="slim ? '25px' : ''"
         [style.padding]="slim ? 0 : ''"
         [style.opacity]="isDisabled ? 0.5 : 1">
      <ng-container *ngTemplateOutlet="uploadFilesTemplate; context: {slim: slim}"></ng-container>
    </div>
    <div *ngIf="isDisabled" class="file-drop-area" [style.opacity]="isDisabled ? 0.5 : 1">
      <ng-container *ngTemplateOutlet="uploadFilesTemplate"></ng-container>
    </div>
  </ng-container>
</ng-template>



<!--No drag and drop template-->
<ng-template #noDragAndDrop>
  <div class="file-drop-area" [style.opacity]="isDisabled ? 0.5 : 1">
    <ng-container *ngTemplateOutlet="uploadFilesTemplate"></ng-container>
  </div>
</ng-template>

<ng-template #uploadFilesTemplate let-slim="slim">
  <ng-container *ngTemplateOutlet="addingFileInstructionsAndButtonTemplate; context: {slim: slim}"></ng-container>
  <ng-container *ngIf="allowMultipleFiles else singleFile">
    <input #fileInputMulti class="file-input" type="file" multiple [accept]="acceptedFileTypes" [disabled]="isDisabled">
  </ng-container>

</ng-template>

<!--single file template-->
<ng-template #singleFile>
  <input class="file-input" type="file"  [accept]="acceptedFileTypes">
</ng-template>


<!--adding files template-->
<ng-template #addingFileInstructionsAndButtonTemplate let-slim="slim">
  <div class="adding-file-container" *ngIf="!slim">
<!--    <img src="assets/icons/upload_icon.png" id="upload_icon">-->
    <i class="fa-light fa-arrow-up-from-bracket pink"></i>
    <span  home365Link>{{allowMultipleFiles ? ('GENERAL_FORMS.UPLOAD_DRAG_MULTIPLE_FILES' | translate) : ('GENERAL_FORMS.UPLOAD_DRAG_SINGLE_FILE' | translate) }}</span>
    <p >{{descriptionText}}</p>
  </div>

    <div *ngIf="slim" class="adding-file-container" [style.position]="'relative'" [style.flex-direction]="'row'" [style.justify-content]="'center'">
<!--      <img src="assets/icons/upload_icon.png" id="upload_icon_slim" style="width: 20px; height: 20px">-->
      <i class="fa-light fa-arrow-up-from-bracket pink" id="upload_icon_slim" style="width: 20px; height: 20px"></i>
      <p>Drag files here</p>
    </div>
</ng-template>



  <ng-container>
    <div class="upload-files-container flex">
      <ng-container *ngFor="let fileProgress of fileProgress$ | async | keyvalue">
        <div class="file-progress-and-status" *ngIf="fileProgress.value.uploading">
          <ng-container *ngTemplateOutlet="fileUploadingStatus; context: {key: fileProgress.key, fileProgress: fileProgress.value}"></ng-container>
        </div>
      </ng-container>
    </div>

  </ng-container>

<ng-template #fileUploadingStatus let-key=key let-fileStatus=fileProgress>
  <p class="fileName">{{fileStatus.name}}</p>
  <p class="filesize" *ngIf="fileStatus?.file?.size">{{formatBytes(fileStatus.file.size, 0)}}</p>
  <mat-progress-bar *ngIf="fileStatus.uploading" mode="indeterminate"></mat-progress-bar>
  <div class="already-uploaded-file" *ngIf="!fileStatus.uploading">
    <mat-progress-bar  mode="determinate" value="100"></mat-progress-bar>
    <i class="material-icons pointer close-icon gray-icon"
       *ngIf="!isDisabled"
       (click)="removeFile(key)">close</i>
  </div>
  <mat-progress-bar *ngIf="!fileStatus.uploading && fileStatus.failed" mode="determinate" value="100" class="progress-bar fill-danger"></mat-progress-bar>
</ng-template>
</ng-container>

<ng-template #noteTemplate>
<div class="note-template" >

  <div class="adding-file-placeholder"
       *ngIf="!isDisabled"
       appDragAndDrop
       
       (fileDropped)="addFiles($event)">
    <input #fileInputMulti class="file-input" type="file" multiple [accept]="acceptedFileTypes" [disabled]="isDisabled">
<!--    <div class="adding-file-container">-->
     {{('GENERAL_FORMS.UPLOAD_DRAG_MULTIPLE_FILES' | translate) }}

<!--    </div>-->
  </div>






  <ng-container *ngIf="activeFiles?.length > 0">
    <ng-container *ngTemplateOutlet="thumbnails"></ng-container>
  </ng-container>
  <div class="count-error" *ngIf="showCountError" [ngClass]="{'moveUp': activeFiles?.length === 0}">
    <i class="fa-solid fa-triangle-exclamation"></i>&nbsp;&nbsp;
    {{('GENERAL_FORMS.TOO_MANY_FILES' | translate).replace('*|count|*', limitUploadCount) }}
  </div>

  <div class="upload-files-container loadingContainer">
    <ng-container *ngFor="let fileProgress of fileProgress$ | async | keyvalue">
      <div class="file-progress-and-status-notes" *ngIf="fileProgress.value.uploading">
        <ng-container *ngTemplateOutlet="fileUploadingStatus; context: {key: fileProgress.key, fileProgress: fileProgress.value}"></ng-container>
      </div>
    </ng-container>
  </div>

</div>







  <ng-template #fileUploadingStatus let-key=key let-fileStatus=fileProgress>
    <div class="file-loader-spinner">
      <home365-loader [diameter]="30"></home365-loader>
    </div>
  </ng-template>

  <ng-template #thumbnails>
    <lib-carousel
      (events)="handleCarouselEvents($event)"
      class="home365-carousel"
      [allowPrimaryCellsSelection]="allowPrimaryCellsSelection"
      [allowPrimaryTypes]="allowPrimaryTypes"
      [isOwner]="isOwner"
      [cellsToShow]="cellsToShowCarousel"
      [images]="imagesCarousel"
      [arrowsOutside]="true"
      [cellWidth]="cellWidthCarousel"
      [height]="heightCarousel"
      [borderRadius]="borderRadiusCarousel"
      [objectFit]="objectFitCarousel"
      [arrowsTheme]="'dark'"
      [allowDelete]="!isDisabled"
      [leftArrow]="-40"
      [maxCellWidth]="isNote ? 100 : 0"
    ></lib-carousel>
  </ng-template>


</ng-template>


<ng-template #filesLimitErrorTemplate>
  <div class="files-limit-msg">
    <div class="content">{{'GENERAL_FORMS.MAX_FILES_LIMIT' | translate : {limit : limitUploadCount} }}</div>
  </div>
</ng-template>

